import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useMultiStyleConfig as p, useBreakpointValue as g, Flex as u, VStack as m } from "@chakra-ui/react";
import { Typography as c } from "../../dataDisplay/Typography/Typography.mjs";
import l from "./headerImage.svg.mjs";
import f from "./headerImageMobile.svg.mjs";
const y = ({ bottomElement: t, children: e, topElement: a, ...n }) => {
  const o = p("PageHeader"), s = g({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ r(
    u,
    {
      sx: o.container,
      ...n,
      background: s ? `url("${f}")` : `url("${l}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top right",
      backgroundSize: "auto",
      children: /* @__PURE__ */ i(m, { sx: o.content, spacing: 4, align: "stretch", children: [
        a,
        typeof e == "string" || typeof e == "number" ? /* @__PURE__ */ r(c, { variant: "h1", as: "h1", children: e }) : e,
        t
      ] })
    }
  );
};
export {
  y as PageHeader
};
